import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import type { RootState } from 'common/store/types';

type TErrorTypes = 'UNAUTHORIZED'
| 'UNAUTHENTICATED'

type TError = {
  type: TErrorTypes | null,
}

const initialState: TError = {
  type: null,
}

const errorSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    triggerError: (
      state,
      { payload: { type } }: PayloadAction<TError>,
    ) => {
      state.type = type;
    },
    clearError: (state) => {
      state.type = errorSlice.getInitialState().type;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state.type = errorSlice.getInitialState().type;
    });
  },
});

export const { triggerError, clearError } = errorSlice.actions;

export default errorSlice.reducer;

export const selectCurrentClient = (state: RootState) => state.auth;
